// --------------------------------------------------------

// Header visuals effect

let visual = document.getElementById("visual");
let visual2 = document.getElementById("visual2");

let offset = 0;
let dir = 1;


// setInterval(() => {
//     let max = visual.clientWidth - window.innerWidth;
    
//     updateVisuals([visual, visual2]);
//     offset += dir * 1.5;

//     if(offset >= max) {
//         dir = -1;
//         offset = max;
//     } else if(offset <= 0) {
//         dir = 1;
//         offset = 0;
//     }
// }, 10);

document.addEventListener("mousemove", (event) => {
    offset = event.clientX * 0.05;
    updateVisuals([visual, visual2]);
});

function updateVisuals(visuals) {

    for (const element of visuals) {
        // visual.style.transform = `translateX(-${window.scrollY}px)`;
        element.style.transform = `translateX(-${offset}px)`;

    }
}

// --------------------------------------------------------

